module.exports = __webpack_public_path__ + "img/slide12.169bbf85.png";